import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-reassign-final',
  templateUrl: './reassign-final.component.html',
  styleUrls: ['./reassign-final.component.scss']
})
export class ReassignFinalComponent implements OnInit {
  teacherReassignForm: FormGroup;
  candidatesList: any[] = [];
  filteredCandidates: any[] = [];
  searchText: string = '';

  constructor(
    public fb: FormBuilder,
    private umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private dialogRef2: MatDialogRef<ReassignFinalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      iETechId: number, 
      sessionId: number, 
      candidates: any[], 
      currentSlot: any 
    }
  ) { }

  ngOnInit(): void {
    this.teacherReassignForm = this.fb.group({
      selectedTeacherId: new FormControl(''),
      search: new FormControl('')
    });

    this.candidatesList = this.data.candidates || [];
    this.filteredCandidates = [...this.candidatesList];

    this.teacherReassignForm.get('search').valueChanges.subscribe(value => {
      this.searchText = value;
      this.filterCandidates();
    });
  }

  filterCandidates() {
    if (!this.searchText) {
      this.filteredCandidates = [...this.candidatesList];
    } else {
      const searchLower = this.searchText.toLowerCase();
      this.filteredCandidates = this.candidatesList.filter(candidate =>
        candidate.TeacherName?.toLowerCase().includes(searchLower) ||
        candidate.TeacherCgCode?.toLowerCase().includes(searchLower) ||
        candidate.DsCode?.toLowerCase().includes(searchLower) ||
        candidate.TeacherType?.toLowerCase().includes(searchLower)
      );
    }
  }

  submitFinalReassign() {
    const selectedTeacherId = this.teacherReassignForm.get('selectedTeacherId').value;
    if (!selectedTeacherId) {
      this.showError('Please select a teacher from the list.');
      return;
    }

    this.spinner.show();
    const payload = {
      IETechId: this.data.iETechId,
      NewTechId: selectedTeacherId,
      Remarks: 'Final reassigned by supervisor'
    };

    this.umsService.replaceFinalTeacher(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('API Response:', res);
        let isSuccess = false;
        let errorMessage = 'Final reassign failed.';

        if (res.Status === 'SUCCESS') {
          isSuccess = true;
        } else if (res.data && res.data.Status === 'SUCCESS') {
          isSuccess = true;
        } else if (Array.isArray(res) && res[0] && res[0].Status === 'SUCCESS') {
          isSuccess = true;
        } else if (res.status === true) {
          isSuccess = true;
        }

        if (isSuccess) {
          this.showSuccess('Examiner final reassigned successfully.');
          this.dialogRef2.close({ refresh: true });
        } else {
          if (res.Message) errorMessage = res.Message;
          else if (res.data && res.data.Message) errorMessage = res.data.Message;
          else if (res.message) errorMessage = res.message;
          this.showError(errorMessage);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(err.error?.message || 'Server error during final reassign.');
      }
    });
  }

  private showError(msg: string) {
    const data = { message: msg, title: 'Error', icon: 'fas fa-times' };
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  private showSuccess(msg: string) {
    const data = { message: msg, title: 'Success', icon: 'fas fa-check' };
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  closeDialog() {
    this.dialogRef2.close();
  }
}